// import {AuthContext} from '@/helpers/Auth/AuthProvider'
import {useAuth} from '@/hooks/useAuth'
import {Alert} from '@/shared-components/Alert'
import {selectShellActive, selectShellPath, setShellPath} from '@/store/slices/commonSlice'
import {resetNotifications} from '@ReduxActions'
import {PropsWithChildren, useCallback, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import logo from '../../assets/img/logo-pepsico-h.svg'
import {Header} from '../../shared-components/Header'
import {SidebarMenu} from '../../shared-components/SidebarMenu'
import {useAppDispatch, useAppSelector} from '../../store'
import {HeaderExtraItems} from './components/HeaderExtraItems'

export const Template = ({children}: PropsWithChildren) => {
  // const {isAuthenticated} = useContext(AuthContext)
  const {isAuthenticated, isCypress} = useAuth()
  const shellActive = useAppSelector(selectShellActive)
  const shellAuthenticated = shellActive && !!localStorage.getItem('msalAccessToken')
  return isAuthenticated || isCypress || shellAuthenticated ? (
    <Logged>{children}</Logged>
  ) : (
    <NotLogged>{children}</NotLogged>
  )
}

const Logged = (props: PropsWithChildren) => {
  const {formatMessage} = useIntl()
  const {show, type, message} = useAppSelector(state => state.notifications)
  const shellActive = useAppSelector(selectShellActive)
  const shellPath = useAppSelector(selectShellPath)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const onCloseAlert = useCallback(() => {
    dispatch(resetNotifications())
  }, [dispatch])

  useEffect(() => {
    // important: immediately navigate to shellPath received from the top shell & reset it
    if (shellActive && shellPath) {
      navigate(shellPath)
      dispatch(setShellPath(''))
    }
  }, [shellActive, shellPath, navigate, dispatch])

  return (
    <>
      {!shellActive && (
        <Header logo={logo} title={formatMessage({id: 'GENERAL.APP_NAME'})}>
          <HeaderExtraItems />
        </Header>
      )}

      <div data-testid="content" className="relative flex h-full max-h-[calc(100vh-4rem)]">
        {!shellActive && <SidebarMenu />}
        <main
          data-testid="content-main"
          data-cy="content-main"
          className={`${!shellActive ? 'ml-20' : ''} w-full overflow-auto bg-background pl-7 pr-6 pt-8 text-zinc-800`}
          {...props}
        />
        <Alert data-cy="feedback-alert" type={type} message={message} show={show} onCloseClick={onCloseAlert} />
      </div>
    </>
  )
}

const NotLogged = (props: PropsWithChildren) => {
  return (
    <div data-testid="content" className="relative flex h-full">
      <main data-testid="content-main-guest" className="h-full w-full bg-background px-4 text-zinc-800" {...props} />
    </div>
  )
}
